/* eslint-disable */
import React from "react";
// @material-ui/core components
import {
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import ls from "local-storage";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import Button from "components/CustomButtons/Button.js";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";
import PhotoCamera from "@material-ui/icons/PhotoCamera";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import styles from "assets/jss/material-dashboard-react/views/EventStyle.js";
import { db, storage } from "../Firebase/firebase.js";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);
const tablestyle = {
  backgroundColor: "#171942",
  color: "white",
};

export default function Customers() {
  let history = useHistory();
  const theme = useTheme();
  var mobileratio = useMediaQuery(theme.breakpoints.down("sm"));
  var desktop = useMediaQuery(theme.breakpoints.between("2490", "4000"));
  const [user_type, setType] = React.useState("");
  const [rows, setRow] = React.useState([]);
  const [viewname, setviewname] = React.useState("");
  const [docid, setDocid] = React.useState("");
  const [viewemail, setviewemail] = React.useState("");
  const [viewflag, setviewflag] = React.useState(false);
  const searchref = React.useRef("");
  const [searchflag, setsearchflag] = React.useState(true);
  

  
 

  
  const handleTypeChange = (event) => {
    setType(event.target.value);
  };
  const [openViewDialog, setViewDialog] = React.useState(false);


  const handleViewClickOpen = () => {
    setViewDialog(true);
  };
  const handleViewArrowClose = () => {
    setViewDialog(false);
  };

  React.useEffect(() => {
    if (ls.get("currentuser") === "") {
      history.push("/login");
     
    } else {
      getCustomers();
    }
  }, []);
  var getCustomers = () => {
    let newArray = [];
    db.collection("users").where("type","!=","admin")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          newArray.push(doc.data());
        });
        setRow(newArray);
      })
      .catch((error) => {
        console.log("Error getting documents: ", error);
      });
  };
  const searchCustomer = () => {
    if (searchflag === true) {
      let newArray = [];
      db.collection("users")
        .where("email", "==", searchref.current.value)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            newArray.push(doc.data());
          });
          setRow(newArray);
          setsearchflag(false);
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    } else {
      searchref.current.value = "";
      getCustomers();
      setsearchflag(true);
    }
  };
  const viewCustomer = (row) => {
    setviewflag(true);
    setviewname(row.displayName);
    setType(row.type);
    setviewemail(row.email);
    setViewDialog(true);
  };

  const updateCustomerDialog = (row) => {
    setviewflag(false);
    setviewname(row.displayName);
    setviewemail(row.email);
    setType(row.type);
    setDocid(row.uid);
    setViewDialog(true);
  };
  const handleViewClose = () => {
    if (setviewflag === true) {
      setViewDialog(false);
    } else {
      updateCustomer();
    }
  };

  



  const updateCustomer = () => {
    console.log(docid);
    db.collection('users').doc(docid).set(
        {
            type:user_type,
        },
        {merge:true}
    )
    .then(() => {
        setViewDialog(false);
        setTimeout(() => {
          getCustomers();
        }, 2000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  
  const classes = useStyles();
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  return (
    <>
      <GridContainer justify="flex-end">
        <GridItem xs={12} sm={6} md={4}>
          <div style={{ marginLeft: desktop ? "495px" : "80px" }}>
            <TextField
              placeholder="Search"
              variant="outlined"
              inputRef={searchref}
              InputProps={{
                endAdornment: (
                  <InputAdornment>
                    <IconButton onClick={searchCustomer}>
                      {searchflag ? <SearchIcon /> : <ClearIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </GridItem>
      </GridContainer>
      <br></br>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <TableContainer
            component={Paper}
            style={{
              height: 450,
              overflow: "scroll",
              overflowX: "auto",
              display: "inline-block",
            }}
          >
            <Table
              stickyHeader
              style={{ width: "100%" }}
              className={classes.table}
              aria-label="customized table"
            >
              <TableHead>
                <TableRow>
                  <TableCell style={tablestyle}>ID</TableCell>
                  <TableCell style={tablestyle} align="left">
                    Name
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Email
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Type
                  </TableCell>
                  <TableCell style={tablestyle} align="left">
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <StyledTableRow key={row.uid}>
                    <TableCell
                      onClick={() => viewCustomer(row)}
                      style={{ color: "skyblue" }}
                      component="th"
                      scope="row"
                    >
                      {row.uid}
                    </TableCell>

                    <TableCell align="left">{row.displayName}</TableCell>
                    <TableCell align="left">{row.email}</TableCell>
                    <TableCell align="left">{row.type}</TableCell>
                    <TableCell align="left">
                      <div>
                        <IconButton onClick={()=>updateCustomerDialog(row)}>
                          <EditIcon style={{ color: "green", width: "18" }} />
                        </IconButton>
                      </div>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </GridItem>
      </GridContainer>
      <GridContainer justify="flex-end">
        <GridItem>
          <br></br>
         
          

          <Dialog
            open={openViewDialog}
            onClose={handleViewArrowClose}
            aria-labelledby="Customer-title"
            aria-describedby="Customer-description"
            fullScreen={mobileratio ? true : false}
          >
            <DialogTitle id="customer-header" style={{ paddingLeft: "0" }}>
              <div>
                <IconButton onClick={handleViewArrowClose}>
                  <i className="fa fa-chevron-circle-left fa-lg"></i>
                </IconButton>
              </div>
            </DialogTitle>
            <DialogContent style={{ height: 800, width: 600 }}>
              <div className="customer-form">
                <div>
                  {mobileratio ? <br></br> : <br></br>}
                  {viewflag ? (
                    <TextField
                      value={user_type}
                      required
                      label="User Type"
                      variant="outlined"
                      style={{ width: mobileratio ? 262 : 535 }}
                    />
                  ) : (
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                      style={{ width: mobileratio ? 262 : 535 }}
                      required
                    >
                      <InputLabel id="type_label">User Type</InputLabel>

                      <Select
                        labelId="type_id"
                        id="user_type"
                        value={user_type}
                        onChange={handleTypeChange}
                        label="User Type"
                      >
                        <MenuItem value={"customer"}>Customer</MenuItem>
                        <MenuItem value={"employee"}>Employee</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </div>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  value={viewname}
                  required
                  label="Name"
                  variant="outlined"
                  style={{ width: mobileratio ? 262 : 535 }}
                />
                <br></br>
                {mobileratio ? <br></br> : <br></br>}
                <TextField
                  value={viewemail}
                  required
                  label="Email"
                  variant="outlined"
                  style={{ width: mobileratio ? 262 : 535 }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                style={{
                  marginRight: mobileratio ? 75 : 15,
                  width: mobileratio ? 267 : 555,
                  backgroundColor: "#171942",
                }}
                onClick={handleViewClose}
              >
                {viewflag ? "close" : "Update"}
              </Button>
            </DialogActions>
          </Dialog>
        </GridItem>
      </GridContainer>

      
    </>
  );
}
